<div class="date-picker-container" [class.open]="isOpen()">
  <div
    class="input-wrapper"
    (click)="togglePicker()"
    (keydown.enter)="togglePicker()"
    tabindex="0"
    role="button"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isOpen()"
  >
    <input
      type="text"
      [placeholder]="placeholder"
      [value]="formattedDate()"
      readonly
      class="date-input"
      tabindex="-1"
    />
    <svg class="calendar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>

    @if (value()) {
      <button type="button" class="clear-btn" (click)="clearValue($event)" aria-label="Clear date">
        <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    }
  </div>

  @if (isOpen()) {
    <div
      class="picker-dropdown"
      [class.align-right]="dropdownAlign === 'right'"
      (click)="$event.stopPropagation()"
      (keydown.escape)="closePicker()"
      role="dialog"
      aria-label="Calendar"
    >
      <div class="picker-header">
        <button type="button" class="nav-btn" (click)="prevPage()" aria-label="Previous">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button type="button" class="view-label-btn" (click)="toggleMode()">
          @if (mode() === 'days') {
            {{ monthNames[viewDate().getMonth()] }} {{ viewDate().getFullYear() }}
          } @else if (mode() === 'months') {
            {{ viewDate().getFullYear() }}
          } @else {
            {{ yearRangeStart() }} - {{ yearRangeStart() + 11 }}
          }
        </button>

        <button type="button" class="nav-btn" (click)="nextPage()" aria-label="Next">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>

      @if (mode() === 'days') {
        <div class="weekdays" role="row">
          @for (day of weekDays; track day) {
            <div class="weekday" role="columnheader">{{ day }}</div>
          }
        </div>

        <div class="days-grid">
          @for (day of calendarDays(); track day.date.getTime()) {
            <div
              class="day-cell"
              [class.current-month]="day.currentMonth"
              [class.today]="day.isToday"
              [class.selected]="isSelected(day.date)"
              [class.disabled]="isDisabled(day.date)"
              (click)="selectDate(day.date)"
              (keydown.enter)="selectDate(day.date)"
              [tabindex]="day.currentMonth && !isDisabled(day.date) ? 0 : -1"
              role="gridcell"
              [aria-selected]="isSelected(day.date)"
              [attr.aria-label]="day.date.toDateString()"
            >
              {{ day.date.getDate() }}
            </div>
          }
        </div>
      } @else if (mode() === 'months') {
        <div class="selection-grid months">
          @for (month of monthNames; track month; let i = $index) {
            <button
              type="button"
              class="selection-cell"
              [class.selected]="viewDate().getMonth() === i"
              (click)="selectMonth(i)"
            >
              {{ month.substring(0, 3) }}
            </button>
          }
        </div>
      } @else if (mode() === 'years') {
        <div class="selection-grid years">
          @for (year of yearOptions(); track year) {
            <button
              type="button"
              class="selection-cell"
              [class.selected]="viewDate().getFullYear() === year"
              (click)="selectYear(year)"
            >
              {{ year }}
            </button>
          }
        </div>
      }

      <div class="picker-footer">
        <button type="button" class="footer-btn today-btn" (click)="setToday()">Today</button>
        <button type="button" class="footer-btn clear-footer-btn" (click)="clearValue()">
          Clear
        </button>
      </div>
    </div>
  }
</div>
